import { Grid, Stack, styled } from "@mui/material";
import { customColors } from "models/customColors";

const responsiveFontSize = `  
  font-family: "Inter Medium";
  font-size: 13px;
    
  @media (max-width: 1600px) {
    font-size: 12px;
  }

  @media (max-width: 1440px) {
    font-size: 11px;
  }

  @media (max-width: 1280px) {
    font-size: 10px;
  }
  @media (max-width: 480px) {
    font-size: 9px;
  }
`;

export const RecordsHolder = styled(Grid)`
  flex: 1 1 auto;

  min-height: 30px;
  min-width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  border-left: thin solid lightgray;
  border-right: thin solid lightgray;
  background-color: ${customColors.white};
`;

export const Record = styled(Grid)`
  padding: 6px 24px;

  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover {
    background-color: ${customColors.selector};
  }

  &.highlighted-row {
    background-color: ${customColors.newReferralBackground};
  }

  &.highlighted-row:hover {
    background-color: ${customColors.newReferralBackgroundHover};
  }

  @media (max-width: 768px) {
    padding: 6px 24px;
  }

  @media (max-width: 480px) {
    padding: 6px 12px;
  }
`;

export const RecordItem = styled(Grid)`
  color: ${customColors.text};
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  word-wrap: break-word;
  height: "100%";
  ${responsiveFontSize};
`;

export const Header = styled(Grid)`
  padding: 16px 24px 16px 24px;

  flex: 0 0 auto;

  display: flex;
  flex-direction: row;
  align-items: center;

  font-family: "Inter Bold";

  border-top: thin solid lightgray;
  border-left: thin solid lightgray;
  border-top-left-radius: 5px;
  border-right: thin solid lightgray;
  border-top-right-radius: 5px;

  overflow-y: scroll;
  scrollbar-color: transparent transparent;
  
  &:hover {
    color: ${customColors.selector};
  }

  @media (max-width: 768px) {
    padding: 8px 24px 8px 24px;
  }

  @media (max-width: 480px) {
    padding: 8px 14px 8px 12px;
  }
`;

export const HeaderItemWithoutSorter = styled(Stack)`
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;

  line-height: 18px; /* 112.5% */

  color: ${customColors.gridHeaderText};
  user-select: none;

  word-wrap: break-word;
  word-break: break-all;

  ${responsiveFontSize}
`;

export const HeaderItem = styled(HeaderItemWithoutSorter)`
  cursor: pointer;

  &:hover {
    color: ${customColors.mainColor};
  }
`;

export const PaginationContainer = styled(Stack)`
  padding: 5px 20px 5px 5px;

  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem;

  border-bottom: thin solid lightgray;
  border-left: thin solid lightgray;
  border-bottom-left-radius: 5px;
  border-right: thin solid lightgray;
  border-bottom-right-radius: 5px;

  @media (max-width: 640px) {
    justify-content: space-around;
  }

`;

export const RecordsPerPageSelector = styled(Stack)`
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;

  font-family: Inter;
  font-size: 12px;
  font-style: normal;
`;

export const NoDataHolder = styled(Stack)`
  flex: 1 1 auto;
  height: 50%;
  min-height: 30px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;

  color: ${customColors.grayText};
`;
